import request from '@/utils/request'

// 获取菜单列表（树形结构）
export const getMenuList = (data) => {
  return request({
    url: '/system/menu/list',
    method: 'get',
    params: data
  })
}

// 获取菜单路由信息
export const getRouters = () => {
  return request({
    url: '/system/menu/getRouters',
    method: 'get'
  })
}

// 新增菜单
export const addMenu = (data) => {
  return request({
    url: '/system/menu',
    method: 'post',
    data
  })
}

// 修改菜单
export const updateMenu = (data) => {
  return request({
    url: '/system/menu',
    method: 'put',
    data
  })
}

// 删除菜单
export const deleteMenu = (menuId) => {
  return request({
    url: `/system/menu/${menuId}`,
    method: 'delete'
  })
}
